import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";

export default function Blog() {
    const [posts, setPosts] = useState([]);
    const [cat, setCat] = useState("");
    const cats = ["vinhos portugueses", "harmonização", "produtores artesanais", "lifestyle"];

    useEffect(() => {
        api.get("/blog", { params: cat ? { category: cat } : {} }).then((r) => setPosts(r.data));
    }, [cat]);

    return (
        <>
            <Navbar variant="light" />
            <section className="pt-32 pb-12 bg-beige-natural border-b border-wine-dark/10">
                <div className="container-edge max-w-4xl">
                    <span className="label-overline text-wine">Diário Caseirinho</span>
                    <h1 className="mt-4 font-heading text-5xl md:text-7xl text-wine-dark leading-[0.95]">
                        Notas de vinha e mesa.
                    </h1>
                </div>
                <div className="container-edge mt-8 flex flex-wrap gap-3">
                    <button onClick={() => setCat("")} className={`label-overline px-4 py-2 border ${!cat ? "bg-wine text-beige-natural border-wine" : "border-wine-dark/20 text-wine-dark hover:border-wine"}`}>
                        Tudo
                    </button>
                    {cats.map((c) => (
                        <button
                            key={c}
                            onClick={() => setCat(c)}
                            className={`label-overline px-4 py-2 border ${cat === c ? "bg-wine text-beige-natural border-wine" : "border-wine-dark/20 text-wine-dark hover:border-wine"}`}
                            data-testid={`blog-cat-${c}`}
                        >
                            {c}
                        </button>
                    ))}
                </div>
            </section>
            <section className="bg-beige-natural py-16">
                <div className="container-edge grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {posts.map((p) => (
                        <Link key={p.id} to={`/blog/${p.slug}`} className="group block" data-testid={`blog-card-${p.slug}`}>
                            <div className="aspect-[4/3] overflow-hidden bg-beige-warm">
                                <img src={p.cover} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                            </div>
                            <div className="mt-5">
                                <span className="label-overline text-wine/60">{p.category}</span>
                                <h2 className="mt-3 font-heading text-2xl text-wine-dark leading-tight group-hover:text-wine">{p.title}</h2>
                                <p className="mt-3 text-sm text-wine-dark/70">{p.excerpt}</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
            <Footer />
        </>
    );
}
